unit UAppForLeaveConfig;

interface

type
  TAppForLeaveConfig = class
  private
    FApplicationCount: Integer;
    FApplicationCanceled: Integer;
    FApplicationApproved: Integer;
    FApplicationNew: Integer;
    FApplicationRejected: Integer;
    FApplicationInProcess: Integer;
    FZaResturlaubId: Integer;
    FZaUrlaubId: Integer;
    FConfirmation: Boolean;
    procedure ClearValues;
    procedure SetValues(json: string);
    procedure SetApplicationApproved(const Value: Integer);
    procedure SetApplicationCanceled(const Value: Integer);
    procedure SetApplicationCount(const Value: Integer);
    procedure SetApplicationInProcess(const Value: Integer);
    procedure SetApplicationNew(const Value: Integer);
    procedure SetApplicationRejected(const Value: Integer);
    procedure SetZaResturlaubId(const Value: Integer);
    procedure SetZaUrlaubId(const Value: Integer);
    procedure SetConfirmation(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property ApplicationCount: Integer read FApplicationCount write SetApplicationCount;
    property ApplicationNew: Integer read FApplicationNew write SetApplicationNew;
    property ApplicationInProcess: Integer read FApplicationInProcess write SetApplicationInProcess;
    property ApplicationApproved: Integer read FApplicationApproved write SetApplicationApproved;
    property ApplicationRejected: Integer read FApplicationRejected write SetApplicationRejected;
    property ApplicationCanceled: Integer read FApplicationCanceled write SetApplicationCanceled;
    property ZaResturlaubId: Integer read FZaResturlaubId write SetZaResturlaubId;
    property ZaUrlaubId: Integer read FZaUrlaubId write SetZaUrlaubId;
    property Confirmation: Boolean read FConfirmation write SetConfirmation;
  end;

implementation

uses
  Js, System.SysUtils, UEssentialHelper;

{ TAppForLeaveConfig }

procedure TAppForLeaveConfig.ClearValues;
begin
  Self.ApplicationCount:=10;
  Self.ApplicationNew:=$00FFFF;
  Self.ApplicationInProcess:=$4080FF;
  Self.ApplicationApproved:=$008000;
  Self.ApplicationRejected:=$0000FF;
  Self.ApplicationCanceled:=$FF0000;
  Self.ZaResturlaubId:=35;
  Self.ZaUrlaubId:=31;
  Self.Confirmation:=false;
end;

constructor TAppForLeaveConfig.Create;
begin
  Self.ClearValues;
end;

constructor TAppForLeaveConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TAppForLeaveConfig.SetApplicationApproved(const Value: Integer);
begin
  FApplicationApproved := Value;
end;

procedure TAppForLeaveConfig.SetApplicationCanceled(const Value: Integer);
begin
  FApplicationCanceled := Value;
end;

procedure TAppForLeaveConfig.SetApplicationCount(const Value: Integer);
begin
  FApplicationCount := Value;
end;

procedure TAppForLeaveConfig.SetApplicationInProcess(const Value: Integer);
begin
  FApplicationInProcess := Value;
end;

procedure TAppForLeaveConfig.SetApplicationNew(const Value: Integer);
begin
  FApplicationNew := Value;
end;

procedure TAppForLeaveConfig.SetApplicationRejected(const Value: Integer);
begin
  FApplicationRejected := Value;
end;

procedure TAppForLeaveConfig.SetConfirmation(const Value: Boolean);
begin
  FConfirmation := Value;
end;

procedure TAppForLeaveConfig.SetValues(json: string);
var obj: TJsObject;
begin
  Self.ClearValues;
  obj:=TJsJson.parseObject(json);
  if obj['ApplicationCount']<>nil then
    Self.ApplicationCount:=StrToInt(string(obj['ApplicationCount']));
  if obj['ApplicationNew']<>nil then
    Self.ApplicationNew:=StrToInt(string(obj['ApplicationNew']));
  if obj['ApplicationInProcess']<>nil then
    Self.ApplicationInProcess:=StrToInt(string(obj['ApplicationInProcess']));
  if obj['ApplicationApproved']<>nil then
    Self.ApplicationApproved:=StrToInt(string(obj['ApplicationApproved']));
  if obj['ApplicationRejected']<>nil then
    Self.ApplicationRejected:=StrToInt(string(obj['ApplicationRejected']));
  if obj['ApplicationCanceled']<>nil then
    Self.ApplicationCanceled:=StrToInt(string(obj['ApplicationCanceled']));
  if obj['ZaResturlaubId']<>nil then
    Self.ZaResturlaubId:=StrToInt(string(obj['ZaResturlaubId']));
  if obj['ZaUrlaubId']<>nil then
    Self.ZaUrlaubId:=StrToInt(string(obj['ZaUrlaubId']));
  if obj['Confirmation']<>nil then
    Self.Confirmation:=StrToBoolean(string(obj['Confirmation']));
end;

procedure TAppForLeaveConfig.SetZaResturlaubId(const Value: Integer);
begin
  FZaResturlaubId := Value;
end;

procedure TAppForLeaveConfig.SetZaUrlaubId(const Value: Integer);
begin
  FZaUrlaubId := Value;
end;

end.
